<template>
  <div id="contenedor-obras-picker" class="rounded-lg pa-1 elevation-2">
    <h3 class="pl-2 pt-2 d-flex align-center">
      <v-icon>
        mdi-check-all
      </v-icon>
      <span class="ml-1">
        Seleccionador de obras
        <v-chip
          small
          color="transparent"
          :disabled="obrasSeleccionadas.length <= 0">
          {{ obrasSeleccionadas.length }} obra(s) seleccionada(s)
        </v-chip>
      </span>
    </h3>
    <v-row align="center">
      <v-col cols="2">
        <EjercicioPicker v-model="filtros.ejercicio" sinPeriodo></EjercicioPicker>
      </v-col>
      <v-col cols="10">
        <v-autocomplete
          v-model="obrasSeleccionadas"
          :label="getLabel"
          :items="getObras"
          return-object
          :multiple="multiSelect"
          chips
          clearable-chips
          filled
          hide-details
          clearable
          rounded
          class="my-input"
          color="#6A83B5"
          background-color="#F2F6FF"
          item-text="clave"
          :filter="filtro"
          :search-input.sync="search"
          @change="enviarSeleccionados">
          <template
            v-slot:item="data">
            <v-list-item-avatar>
              <v-avatar
                size="24"
                :color="data.item.tipo.color">
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                {{ data.item.clave }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ data.item.meta.slice(0,150) }}...
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import OBRAS from '@/graphql/querys/administracion/planeacion/obras.gql';
import OBRAS_LISTADO_ADJUDICAR from '@/graphql/querys/administracion/obrassolicitudes/obrasSolicitudesListadoParaAdjudicar.gql';
import OBRAS_LISTADO_CONTRATAR from '@/graphql/querys/administracion/obrassolicitudes/obrasSolicitudesListadoParaContratar.gql';
import EjercicioPicker from './inputs/EjercicioPicker.vue';

export default {
  name: 'ObrasPicker',
  components: {
    EjercicioPicker,
  },
  data() {
    return {
      obrasSeleccionadas: [],
      search: '',
      filtros: {
        ejercicio: new Date().getFullYear(),
        buscarTexto: null,
        pagina: 1,
        limite: 10,
        ordenarPor: null,
        orden: null,
      },
    };
  },
  props: {
    obrasContratos: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    multiSelect: {
      type: Boolean,
      required: false,
      default: true,
    },
    para: {
      type: String,
      required: false,
      default: null,
    },
  },
  methods: {
    filtro(item, queryText) {
      const clave = item.clave.toLowerCase();
      const meta = item.meta.toLowerCase();

      const expt = new RegExp(queryText, 'gi');

      return expt.test(clave) || expt.test(meta);
    },
    enviarSeleccionados() {
      // V-MODEL
      this.$emit('input', this.obrasSeleccionadas);
      // ENVIAR SOLO IDS SELECCIONADOS
      if (this.multiSelect === true) {
        this.$emit('solo-ids', this.obrasSeleccionadas.map((obra) => obra.id));
      } else if (this.obrasSeleccionadas !== null) {
        this.$emit('solo-ids', [this.obrasSeleccionadas.id]);
      } else {
        this.$emit('solo-ids', []);
      }
    },
  },
  apollo: {
    obras: {
      query: OBRAS,
      skip() {
        return this.para !== null;
      },
    },
    obrasSolicitudesListadoParaAdjudicar: {
      query: OBRAS_LISTADO_ADJUDICAR,
      variables() {
        return {
          filtros: {
            ejercicio: this.filtros.ejercicio,
            buscarTexto: this.filtros.buscarTexto,
            pagina: this.filtros.pagina,
            limite: this.filtros.limite,
            ordenarPor: this.filtros.ordenarPor,
            orden: this.filtros.orden,
          },
        };
      },
      skip() {
        return this.para !== 'ADJUDICAR';
      },
    },
    obrasSolicitudesListadoParaContratar: {
      query: OBRAS_LISTADO_CONTRATAR,
      variables() {
        return {
          filtros: {
            ejercicio: this.filtros.ejercicio,
            buscarTexto: this.filtros.buscarTexto,
            pagina: this.filtros.pagina,
            limite: this.filtros.limite,
            ordenarPor: this.filtros.ordenarPor,
            orden: this.filtros.orden,
          },
        };
      },
      skip() {
        return this.para !== 'CONTRATAR';
      },
    },
  },
  computed: {
    getLabel() {
      if (this.multiSelect === true) return 'Seleccionar obra(s)';
      return 'Seleccionar obra';
    },
    getObras() {
      if (this.para === 'ADJUDICAR') {
        if (!this.obrasSolicitudesListadoParaAdjudicar) return [];
        return this.obrasSolicitudesListadoParaAdjudicar.map((obraSolicitud) => ({
          id: obraSolicitud.idObra,
          clave: obraSolicitud.obra.clave,
          meta: obraSolicitud.obra.meta,
          tipo: obraSolicitud.obra.tipo,
        }));
      } if (this.para === 'CONTRATAR') {
        if (!this.obrasSolicitudesListadoParaContratar) return [];
        return this.obrasSolicitudesListadoParaContratar.map((obraSolicitud) => ({
          id: obraSolicitud.idObra,
          clave: obraSolicitud.obra.clave,
          meta: obraSolicitud.obra.meta,
          tipo: obraSolicitud.obra.tipo,
        }));
      }
      if (!this.obras) return [];
      return this.obras.map((obra) => ({
        id: obra.id,
        clave: obra.clave,
        meta: obra.meta,
        tipo: obra.tipo,
      }));
    },
  },
  watch: {
    obrasSeleccionadas() {
      this.search = '';
    },
  },
};
</script>

<style lang="scss">
.my-input.v-input .v-input__slot {
  border-radius: 10px;
}
</style>
